import HelloAssoController from "../../controller/HelloAssoController";
import {token, apiError, organization, order_result} from "./@types/HelloAsso";




class HelloAsso{
    
    //properties
    helloAssoController: HelloAssoController; 
    token: token;
    apiError: apiError;
    organization:organization|null;
    orders: order_result|null;

    constructor(){
        this.helloAssoController = new HelloAssoController();
        this.token={
            access_token:null,
            expires_in:0,
            refresh_token:null,
            token_type:null,
            end_validity_timestamp:0
        }
        
    }

    


    /**
     * Retrieve a token for Hello Asso connection
     * if token is expired: will refresh it
     */
    async getToken():Promise<token>{

        //check token validity
        if(this.token.access_token !== null && this.token.end_validity_timestamp > Date.now()){
            //current token is still valid
            return this.token
        }

        else if(this.token.refresh_token !== null){
            //current token needs to be refreshed
            let response = await this.helloAssoController.refreshToken(this.token.refresh_token)
            if(response){
                response['end_validity_timestamp'] = Date.now()+response.expires_in * 1000;
                this.token = response; 
                return this.token;
                
            }else{
                this.apiError = {
                    notifVariant:"error",
                    notifMessage:"Impossible de récupérer la token HelloAsso",
                    notifDescription:"Error from HelloAsso.getToken()"
                }
            }

        }

        //no token
        let response = await this.helloAssoController.getToken();
        //set end validity
        if(response){
            response['end_validity_timestamp'] = Date.now()+response.expires_in * 1000;
            this.token = response; 
            
        }else{
            this.apiError = {
                notifVariant:"error",
                notifMessage:"Impossible de récupérer la token HelloAsso",
                notifDescription:"Error from HelloAsso.getToken()"
            }
        }
        console.log(this.token);
        return this.token;
    }


    /**
     * Get Hello Asso Organization
     * @returns Hello asso Organization
     */
    async getOrganization():Promise<organization|null>{

        let token = await this.getToken();

        if(token.access_token){
            let response = await this.helloAssoController.getOrganization(token.access_token);
            this.organization=response;
        }else{
            this.organization = null;
        }
        return this.organization
    }


    /**
     * Get Hello Asso orders 
     * @returns 
     */
    async getOrders():Promise<order_result|null>{
        let token = await this.getToken();
        if(token.access_token && this.organization?.organizationSlug){
            let response = await this.helloAssoController.getOrders( this.organization?.organizationSlug, token.access_token);
            this.orders=response;
        }else{
            this.orders = null;
        }
        return this.orders
    }


}
export default HelloAsso;